import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { LoadingDialog } from '../../../../../_metronic/_partials/controls';

export function SalesLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.sales ? state.sales.listLoading : false }),
    shallowEqual
  );
  useEffect(() => {}, [isLoading]);
  return <LoadingDialog isLoading={isLoading} text='Уншиж байна ...' />;
}
